import type { IconName } from '@lite-workspace/shared/blocks/icon';
import { supportChannels } from '@lite-workspace/shared/onboarding-service';

/**
 * One app-supplied row of the account menu. The built-in logout row is NOT part of this list —
 * the menu always renders it last and reports the confirmed intent through `logoutConfirmed`.
 */
export interface AccountMenuItem {
  id: string;
  label: string;
  icon?: IconName;
  /** Строка, которую надо заметить: текст и иконка берут акцентный тон вместо обычного. */
  accent?: boolean;
  action: () => void;
  /** Счётчик у правого края строки: сколько сейчас ждёт за этим пунктом. Ноль плашку не рисует. */
  badge?: number;
  /** Приглушённая подпись у правого края строки (длительность ролика). */
  trail?: string;
  /** Closes a group: draws a separator under this row. The row before logout never needs it. */
  separatorAfter?: boolean;
  /** Rows of a submenu: the row gets a chevron and opens them sideways; `action` runs when the submenu opens. */
  children?: readonly AccountMenuItem[];
}

/**
 * The profile rows every non-Fotoclass cabinet shows. The route to its own settings screen is the
 * only thing that differs between products, so the host hands just that over.
 * Runs in an injection context: the support submenu reads the shared channel list.
 */
export function profileMenuItems(openAccountSettings: () => void): AccountMenuItem[] {
  const channels = supportChannels();
  return [
    { id: 'account', label: 'Настройки аккаунта', icon: 'user-outline', action: openAccountSettings, separatorAfter: true },
    {
      id: 'support',
      label: 'Поддержка',
      icon: 'help-circle',
      // Подменю раскрылось — ссылку в Telegram минтим сейчас: к нажатию строки она готова.
      action: () => channels().forEach(channel => channel.prepare?.()),
      // Read on every open: the on-page chat row comes and goes with the support widget.
      get children(): AccountMenuItem[] {
        return channels().map(channel => ({
          id: channel.kind,
          label: channel.label,
          icon: channel.icon,
          separatorAfter: channel.separatorAfter,
          action: channel.open,
        }));
      },
    },
  ];
}
